import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { MenuItem } from '../interfaces/menu-item.interface'
import { TranslateService } from '@ngx-translate/core'
import { environment } from 'environments/environment'

@Injectable({
    providedIn: 'root',
})
export class BenefitsService {
    private menuItems: MenuItem[] = []

    private selectedMenuItemSubject = new BehaviorSubject<MenuItem>(this.menuItems[0])

    constructor(private translate: TranslateService) {
        this.initializeMenuItems()
    }

    private initializeMenuItems(): void {
        this.menuItems = [
            {
                id: 'points',
                label: this.translate.instant('benefits_kb.points.label'),
                content: {
                    title: this.translate.instant('benefits_kb.points.title'),
                    description: this.translate.instant('benefits_kb.points.description'),
                    image: environment.publicUrl + '/assets/images/my-benefits/points-programm.jpg',
                    items: [
                        { title: this.translate.instant('benefits_kb.points.items.0.title'), points: 40 },
                        { title: this.translate.instant('benefits_kb.points.items.1.title'), points: 40 },
                        { title: this.translate.instant('benefits_kb.points.items.2.title'), points: 30 },
                    ],
                },
            },
            {
                id: 'special-prices',
                label: this.translate.instant('benefits_kb.special_prices.label'),
                content: {
                    title: this.translate.instant('benefits_kb.special_prices.title'),
                    description: this.translate.instant('benefits_kb.special_prices.description'),
                    image: environment.publicUrl + '/assets/images/my-benefits/special-prices.jpg',
                    items: [],
                },
            },
            {
                id: 'business-promotion',
                label: this.translate.instant('benefits_kb.business_promotion.label'),
                content: {
                    title: this.translate.instant('benefits_kb.business_promotion.title'),
                    description: this.translate.instant('benefits_kb.business_promotion.description'),
                    image: environment.publicUrl + '/assets/images/my-benefits/promote-your-business.jpg',
                    items: [],
                },
            },
            {
                id: 'events',
                label: this.translate.instant('benefits_kb.events.label'),
                content: {
                    title: this.translate.instant('benefits_kb.events.title'),
                    description: this.translate.instant('benefits_kb.events.description'),
                    image: environment.publicUrl + '/assets/images/my-benefits/events.jpg',
                    items: [],
                },
            },
            {
                id: 'extra-points',
                label: this.translate.instant('benefits_kb.extra_points.label'),
                isPremium: true,
                content: {
                    title: this.translate.instant('benefits_kb.extra_points.title'),
                    description: this.translate.instant('benefits_kb.extra_points.description'),
                    image: environment.publicUrl + '/assets/images/my-benefits/more-points.jpg',
                    items: [],
                },
            },
            {
                id: 'exclusive-colors',
                label: this.translate.instant('benefits_kb.exclusive_colors.label'),
                isPremium: true,
                content: {
                    title: this.translate.instant('benefits_kb.exclusive_colors.title'),
                    description: this.translate.instant('benefits_kb.exclusive_colors.description'),
                    image: environment.publicUrl + '/assets/images/my-benefits/exclusive-colors.jpg',
                    items: [],
                },
            },
            {
                id: 'visit',
                label: this.translate.instant('benefits_kb.visit.label'),
                isPremium: true,
                content: {
                    title: this.translate.instant('benefits_kb.visit.title'),
                    description: this.translate.instant('benefits_kb.visit.description'),
                    image: environment.publicUrl + '/assets/images/my-benefits/hq-travel.jpg',
                    items: [],
                },
            },
        ]

        // Set the initial value after loading
        this.selectedMenuItemSubject.next(this.menuItems[0])
    }

    getMenuItems(): MenuItem[] {
        return this.menuItems
    }

    getSelectedMenuItem(): Observable<MenuItem> {
        return this.selectedMenuItemSubject.asObservable()
    }

    selectMenuItem(id: string): void {
        const menuItem = this.menuItems.find((item) => item.id === id)
        if (menuItem) {
            this.selectedMenuItemSubject.next(menuItem)
        }
    }

    getSelectedMenuItemValue(): MenuItem {
        return this.selectedMenuItemSubject.value
    }
}
